import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[520px] md:min-h-[620px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Aerial%20flatlay%20of%20carefully%20curated%20fashion%20and%20lifestyle%20products%20arranged%20in%20organized%20grid%20on%20light%20oak%20table%2C%20sneakers%20hoodies%20caps%20watches%20and%20bags%20in%20harmonious%20earth%20tones%2C%20morning%20sunlight%20casting%20diagonal%20shadows%20across%20the%20composition%2C%20editorial%20overhead%20product%20photography%2C%20cream%20walls%20in%20background%2C%20clean%20minimalist%20aesthetic%20with%20laptop%20showing%20spreadsheet%20on%20screen&width=1600&height=900&seq=hero-v2-2026-spread&orientation=landscape"
        alt="GTBuy Spreadsheet ultimate shopping comparison hub with curated fashion products"
        title="GTBuy Spreadsheet Shopping Hub 2026"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/40"></div>

      <div className="relative z-10 w-full px-6 md:px-10 text-center">
        <div className="max-w-4xl mx-auto">
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mb-5">
            GTBuy Spreadsheet, Kakobuy Spreadsheet and Superbuy Spreadsheet
          </h1>
          <p className="text-lg md:text-xl text-background-50/80 font-light max-w-2xl mx-auto mb-4">
            Ultimate Shopping Spreadsheet Hub 2026
          </p>
          <p className="text-sm md:text-base text-background-50/65 max-w-xl mx-auto mb-8 leading-relaxed">
            Compare, analyze, and explore the most updated spreadsheet-based shopping systems. Find structured product data, better decision-making tools, and optimized buying guides in one place.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-7 py-3 bg-primary-500 text-background-50 font-semibold text-sm rounded-full hover:bg-primary-600 transition-all duration-300 whitespace-nowrap"
            >
              gtbuy sheet
              <i className="ri-arrow-right-line text-base w-4 h-4 flex items-center justify-center"></i>
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-7 py-3 border border-background-50/30 text-background-50 font-semibold text-sm rounded-full hover:bg-background-50/10 transition-all duration-300 whitespace-nowrap"
            >
              buy it now
              <i className="ri-shopping-bag-line text-base w-4 h-4 flex items-center justify-center"></i>
            </a>
          </div>

          <div className="mt-10 inline-flex items-center gap-3 px-5 py-2.5 bg-background-50/10 backdrop-blur-sm rounded-full">
            <span className="w-1.5 h-1.5 bg-accent-400 rounded-full"></span>
            <Link
              to="/gtbuy-spreadsheet-ultimate-guide"
              className="text-sm text-background-50/85 hover:text-background-50 transition-colors whitespace-nowrap inline-flex items-center gap-1.5"
            >
              Read the Ultimate Guide
              <i className="ri-arrow-right-line text-sm w-3.5 h-3.5 flex items-center justify-center"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}